<script lang="ts" setup>
import { cn } from '@/helpers/tailwind-helpers';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';

const props = defineProps<{
  class?: string;
  fixed?: boolean;
}>();

const bottomButtons = cva('flex flex-col pt-4 space-y-2 bg-white', {
  variants: {
    fixed: {
      true: 'fixed left-0 right-0 bottom-0 pb-[calc(1rem+env(safe-area-inset-bottom))] pl-[calc(1rem+env(safe-area-inset-left,0px))] pr-[calc(1rem+env(safe-area-inset-right,0px))]',
      false: 'pb-4',
    },
  },
});

const classes = computed(() => cn(bottomButtons(props), props.class));
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
